import { render, staticRenderFns } from "./emailgenerate.vue?vue&type=template&id=00bff439&"
import script from "./emailgenerate.vue?vue&type=script&lang=js&"
export * from "./emailgenerate.vue?vue&type=script&lang=js&"
import style0 from "./emailgenerate.vue?vue&type=style&index=0&id=00bff439&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports